export const ALLIANCES_DEFAULT_SORT_BY = "details.name";
export const ALLIANCES_DEFAULT_SORT_ORDER = "asc";

export type AlliancesSearchState = {
  search: string;
  sortBy: string;
  sortOrder: string;
  page: number;
};

export function parseAlliancesSearchParams(
  params: URLSearchParams,
): AlliancesSearchState {
  const sortBy = params.get("sortBy") || ALLIANCES_DEFAULT_SORT_BY;
  const sortOrder = params.get("sortOrder") || ALLIANCES_DEFAULT_SORT_ORDER;
  const search = params.get("search")?.trim() ?? "";
  const page = Math.max(1, Number.parseInt(params.get("page") ?? "1", 10) || 1);
  return { search, sortBy, sortOrder, page };
}

export function buildAlliancesSearchParams(
  state: AlliancesSearchState,
): URLSearchParams {
  const next = new URLSearchParams();
  if (state.search) next.set("search", state.search);
  if (state.sortBy !== ALLIANCES_DEFAULT_SORT_BY)
    next.set("sortBy", state.sortBy);
  if (state.sortOrder !== ALLIANCES_DEFAULT_SORT_ORDER)
    next.set("sortOrder", state.sortOrder);
  if (state.page > 1) next.set("page", String(state.page));
  return next;
}

export function alliancesSortValue(sortBy: string, sortOrder: string): string {
  return `${sortBy}|${sortOrder}`;
}

export function parseAlliancesSortValue(
  sortValue: string,
): Pick<AlliancesSearchState, "sortBy" | "sortOrder"> {
  const [sortBy, sortOrder] = sortValue.split("|");
  return {
    sortBy: sortBy || ALLIANCES_DEFAULT_SORT_BY,
    sortOrder: sortOrder || ALLIANCES_DEFAULT_SORT_ORDER,
  };
}
